import React from "react";
import { Tooltip } from "@mui/material";

export interface GPUHoursBalanceProps {
  balanceRange: string;
  leastExpensiveInstanceType: string;
  maxBalance: number;
  minBalance: number;
  mostExpensiveInstanceType: string;
}
const GPUHoursBalance: React.FC<GPUHoursBalanceProps> = ({
  balanceRange,
  leastExpensiveInstanceType,
  maxBalance,
  minBalance,
  mostExpensiveInstanceType,
}) => {
  return (
    <Tooltip
      title={
        <div className="text-sm flex flex-col gap-2">
          <div>Remaining balance is based on potential usage of:</div>
          <ul className="list-disc list-inside" role="list">
            <li>
              {mostExpensiveInstanceType} for {minBalance} hours
            </li>
            <li>
              {leastExpensiveInstanceType} for {maxBalance} hours
            </li>
          </ul>
        </div>
      }
    >
      <span>{balanceRange}</span>
    </Tooltip>
  );
};

export default GPUHoursBalance;
